import { tget, tpost } from '../../utils/Utils/Utils';

function normalizeTaskPayload(task) {
  if (typeof task === 'string') {
    return { name: task };
  }

  if (task && typeof task === 'object') {
    return task;
  }

  return { name: 'New Task' };
}

export function actionTaskFetchAll() {
  return (dispatch) => {
    tget('/api/v3/torga/task').then((result) => {
      dispatch({ type: 'TASK_FETCH_ALL_COMPLETE', payload: result });
    });
  };
}

export function actionTaskCreate(task, goalID, callback = null) {
  return (dispatch) => {
    const payload = normalizeTaskPayload(task);
    const requestPayload = {
      ...payload,
      ...(goalID ? { goal_id: Number(goalID) } : {}),
    };
    tpost('/api/v3/torga/task', requestPayload).then((result) => {
      dispatch({ type: 'TASK_CREATE_COMPLETE', payload: [result] });
      callback && callback(result);
    });
  };
}

export function actionTaskUpdate(id, field, value) {
  return (dispatch) =>
    tpost(`/api/v3/torga/task/${id}`, { [field]: value }).then((result) => {
      dispatch({ type: 'TASK_UPDATE_COMPLETE', payload: [result] });
    });
}

export function actionTaskDelete(id) {
  return actionTaskUpdate(id, 'deleted', true);
}

export function actionTaskAddToGoal(id, goalID) {
  return actionTaskSetGoal(id, goalID, false);
}

export function actionTaskRemoveFromGoal(id, goalID) {
  return actionTaskSetGoal(id, goalID, true);
}

export function actionTaskSetGoal(id, goalID, deleted = false) {
  return (dispatch) => {
    tpost('/api/v3/torga/goaltask', {
      goal_id: goalID,
      task_id: id,
      deleted,
    }).then((result) => {
      dispatch({ type: 'GOALTASK_UPDATE_COMPLETE', payload: [result] });
    });
  };
}
